/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} NotificationsInputs */

const en_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const fr_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const de_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen`)
};

const it_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifiche`)
};

const ru_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления`)
};

const es_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificaciones`)
};

const zh_cn2_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const ja_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知`)
};

const hi_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाएं`)
};

const pt_pt2_notifications = /** @type {(inputs: NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notificações`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {NotificationsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notifications = /** @type {((inputs?: NotificationsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<NotificationsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_notifications(inputs)
	if (locale === "de") return de_notifications(inputs)
	if (locale === "it") return it_notifications(inputs)
	if (locale === "ru") return ru_notifications(inputs)
	if (locale === "es") return es_notifications(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications(inputs)
	if (locale === "ja") return ja_notifications(inputs)
	if (locale === "hi") return hi_notifications(inputs)
	if (locale === "pt-PT") return pt_pt2_notifications(inputs)
	return en_notifications(inputs)
});